import React from "react";
import { IconButton, iconPlay } from "../../components";

export const PlayButton = (props) => <IconButton src={iconPlay} {...props} />;
